import React from 'react'

/** RTF-4881: Mobile-only feedback banner above the chat, tap to expand full text. */
class MobileFeedbackPreview extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            modalOpen: false,
            isTruncated: false,
        }

        this.textRef = null
        this.measureTruncation = this.measureTruncation.bind(this)
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    componentDidMount () {
        this.measureTruncation()
        // Re-measure after layout/font settle so the clamp count is accurate.
        this._raf = requestAnimationFrame(this.measureTruncation)
        this._measureTimer = setTimeout(this.measureTruncation, 300)
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(this.measureTruncation)
        }
        window.addEventListener('resize', this.measureTruncation)
    }

    componentDidUpdate (prevProps) {
        if (prevProps.feedback?.feedback_id !== this.props.feedback?.feedback_id) {
            if (this.state.modalOpen) {
                this.setState({ modalOpen: false })
            }
            this.measureTruncation()
        }
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.measureTruncation)
        cancelAnimationFrame(this._raf)
        clearTimeout(this._measureTimer)
    }

    // scrollHeight is unreliable under -webkit-line-clamp; un-clamp briefly to read true height.
    measureTruncation () {
        const el = this.textRef
        if (!el) {
            return
        }

        const clampedHeight = el.clientHeight

        el.style.webkitLineClamp = 'unset'
        el.style.display = 'block'
        const fullHeight = el.scrollHeight
        el.style.webkitLineClamp = ''
        el.style.display = ''

        const truncated = fullHeight - clampedHeight > 1
        if (truncated !== this.state.isTruncated) {
            this.setState({ isTruncated: truncated })
        }
    }

    openModal () {
        this.setState({ modalOpen: true })
    }

    closeModal (event) {
        if (event) {
            event.stopPropagation()
        }
        this.setState({ modalOpen: false })
    }

    getName () {
        const feedback = this.props.feedback
        const firstName = feedback.is_include_contact && feedback.user?.firstname ? feedback.user.firstname : ''
        const lastName = feedback.is_include_contact && feedback.user?.lastname ? feedback.user.lastname : ''
        const name = `${firstName} ${lastName}`.trim()

        return name.length === 0 ? __('Anonymous') : name
    }

    getBody () {
        const feedback = this.props.feedback
        const hasText = !!(feedback.description && feedback.description.trim())

        if (hasText) {
            return { text: feedback.description, isFallback: false }
        }

        const text = feedback?.custom_qr_code?.custom_qr_form_id
            ? __('This user has submitted a form')
            : __('This user only left a rating')

        return { text, isFallback: true }
    }

    render () {
        const name = this.getName()
        const { text, isFallback } = this.getBody()
        const label = `${__('Feedback from')} ${name}:`

        return (
            <div className="mobile-feedback-preview">
                <div
                    className="mobile-feedback-preview__banner p-3"
                    role="button"
                    tabIndex={0}
                    onClick={this.openModal}
                >
                    <p
                        className={'mobile-feedback-preview__text' + (isFallback ? ' font-italic' : '')}
                        ref={(el) => { this.textRef = el }}
                    >
                        <span className="mobile-feedback-preview__label">{label}</span>{' '}
                        {text}
                    </p>
                    {this.state.isTruncated &&
                        <span className="mobile-feedback-preview__more"
                              onClick={this.openModal}>{__('read more')}</span>
                    }
                </div>

                {this.state.modalOpen &&
                    <div className="mobile-feedback-modal" onClick={this.closeModal}>
                        <div className="mobile-feedback-modal__card" onClick={(e) => e.stopPropagation()}>
                            <button
                                type="button"
                                className="mobile-feedback-modal__close"
                                aria-label={__('Close')}
                                onClick={this.closeModal}
                            >
                                &#x2715;
                            </button>
                            <p className="mobile-feedback-modal__header">{label}</p>
                            <p className={'mobile-feedback-modal__body' + (isFallback ? ' font-italic' : '')}>
                                {text}
                            </p>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default MobileFeedbackPreview
